import { type BlogArticleCollectionResponse } from '@/modules/blog/types';
import { getContentfulData } from '@/modules/cms/api';
import { isNotNull } from '@/modules/cms/helpers/isNotNull';
import { isProduction } from '@/modules/env/isProduction';

export async function getBlogArticle(slug: string) {
  const query = `query blogArticleEntryQuery {
    blogArticleCollection(where: {slug: "${slug}"}, preview: ${!isProduction()}, limit: 1) {
      items {
        title
        slug
        publishedAt
        youTubeVideoBannerUrl
        body {
          json
          links {
            entries {
              block {
                ... on BlogArticleRow {
                  internalTitle
                  layout
                  reverseOrderOnMobile
                  columnOneContent {
                    json
                    links {
                      assets {
                        block {
                          fileName
                          url
                          title
                          description
                          contentType
                          sys {
                            id
                          }
                        }
                      }
                      entries {
                        block {
                          ... on BlogArticleImageWithLink {
                            image {
                              ...AssetFields
                            }
                            link
                            openInNewTab
                            __typename
                            sys {
                              id
                            }
                          }
                        }
                      }
                    }
                  }
                  columnTwoContent {
                    json
                    links {
                      assets {
                        block {
                          fileName
                          url
                          title
                          description
                          contentType
                          sys {
                            id
                          }
                        }
                      }
                      entries {
                        block {
                          ... on BlogArticleImageWithLink {
                            image {
                              ...AssetFields
                            }
                            link
                            openInNewTab
                            __typename
                            sys {
                              id
                            }
                          }
                        }
                      }
                    }
                  }
                }
                ... on BlogArticleReleaseNotesRow {
                  internalTitle
                  isAppDemoOnLeft
                  isDesktopDemo
                  appDemo {
                    ...AssetFields
                  }
                  content {
                    json
                    links {
                      assets {
                        block {
                          fileName
                          url
                          title
                          description
                          contentType
                          sys {
                            id
                          }
                        }
                      }
                    }
                  }
                }
                ... on BlogArticleQuote {
                  body
                  author {
                    json
                  }
                }
                ... on BlogArticleImageWithLink {
                  image {
                    ...AssetFields
                  }
                  link
                  openInNewTab
                }
                __typename
                sys {
                  id
                }
              }
            }
            assets {
              block {
                fileName
                url
                title
                description
                contentType
                sys {
                  id
                }
              }
            }
          }
        }
        thumbnail {
          ...AssetFields
        }
        banner {
          ...AssetFields
        }
        seo {
          metaTitle
          metaDescription
          canonicalLink
        }
      }
    }
  }
  
  fragment AssetFields on Asset {
    url
    width
    height
    contentType
    description
  }
  `;
  const res = await getContentfulData<BlogArticleCollectionResponse>({ query });

  return res?.data?.data?.blogArticleCollection?.items?.filter(isNotNull)[0];
}
